import { Home, Gamepad2, Backpack, User, Package, TrendingUp, FileText, ShoppingCart, Swords, Crown } from 'lucide-react'

export const getNavigationItems = (t) => [
  {
    path: '/',
    icon: Home,
    label: t('nav.home'),
    exact: true
  },
  {
    path: '/games',
    icon: Gamepad2,
    label: t('nav.games')
  },
  {
    path: '/inventory',
    icon: Backpack,
    label: t('nav.inventory')
  },
  {
    path: '/profile',
    icon: User,
    label: t('nav.profile')
  }
]

export const getGameModeNavigationItems = (t) => [
  {
    id: 'cases',
    title: t('games.cases'),
    icon: Package,
    path: '/cases',
    bgGradient: 'from-accent-primary/10 via-surface/60 to-accent-primary/5',
    borderColor: 'border-accent-primary/50',
    iconBg: 'bg-accent-primary/20',
    iconBorder: 'border-accent-primary/50',
    textColor: 'text-accent-primary',
    badgeBg: 'bg-accent-primary/30',
    badgeBorder: 'border-accent-primary/50',
    shadowColor: 'shadow-accent-primary/20',
    overlayGradient: 'from-accent-primary/5',
    available: true
  },
  {
    id: 'battles',
    title: t('battle.title'),
    icon: Swords,
    path: '/battles',
    isNew: false,
    bgGradient: 'from-red-500/10 via-surface/60 to-red-500/5',
    borderColor: 'border-red-500/50',
    iconBg: 'bg-red-500/20',
    iconBorder: 'border-red-500/50',
    textColor: 'text-red-500',
    badgeBg: 'bg-red-500/30',
    badgeBorder: 'border-red-500/50',
    shadowColor: 'shadow-red-500/20',
    overlayGradient: 'from-red-500/5',
    available: true
  },
  {
    id: 'upgrader',
    title: t('games.upgrader'),
    icon: TrendingUp,
    path: '/upgrader',
    bgGradient: 'from-blue-500/10 via-surface/60 to-blue-500/5',
    borderColor: 'border-blue-500/50',
    iconBg: 'bg-blue-500/20',
    iconBorder: 'border-blue-500/50',
    textColor: 'text-blue-500',
    badgeBg: 'bg-blue-500/30',
    badgeBorder: 'border-blue-500/50',
    shadowColor: 'shadow-blue-500/20',
    overlayGradient: 'from-blue-500/5',
    available: true
  },
  {
    id: 'contracts',
    title: t('games.contracts'),
    icon: FileText,
    path: '/contract',
    bgGradient: 'from-purple-500/10 via-surface/60 to-purple-500/5',
    borderColor: 'border-purple-500/50',
    iconBg: 'bg-purple-500/20',
    iconBorder: 'border-purple-500/50',
    textColor: 'text-purple-500',
    badgeBg: 'bg-purple-500/30',
    badgeBorder: 'border-purple-500/50',
    shadowColor: 'shadow-purple-500/20',
    overlayGradient: 'from-purple-500/5',
    available: true
  },
  {
    id: 'battleRoyale',
    title: t('games.battleRoyale'),
    icon: Crown,
    path: '/royale',
    bgGradient: 'from-yellow-500/10 via-surface/60 to-yellow-500/5',
    borderColor: 'border-yellow-500/40',
    iconBg: 'bg-yellow-500/20',
    iconBorder: 'border-yellow-500/50',
    textColor: 'text-yellow-500',
    badgeBg: 'bg-gray-500/20',
    badgeBorder: 'border-gray-500/30',
    shadowColor: 'shadow-yellow-500/20',
    overlayGradient: 'from-yellow-500/5',
    available: true,
    isNew: true
  },
  {
    id: 'market',
    title: t('market.title'),
    icon: ShoppingCart,
    path: '/market',
    bgGradient: 'from-orange-500/10 via-surface/60 to-orange-500/5',
    borderColor: 'border-orange-500/50',
    iconBg: 'bg-orange-500/20',
    iconBorder: 'border-orange-500/50',
    textColor: 'text-orange-500',
    badgeBg: 'bg-orange-500/30',
    badgeBorder: 'border-orange-500/50',
    shadowColor: 'shadow-orange-500/20',
    overlayGradient: 'from-orange-500/5',
    available: true
  }
]
